import { render, staticRenderFns } from "./Mtr.vue?vue&type=template&id=b2dc6c28&scoped=true"
import script from "./Mtr.vue?vue&type=script&lang=js"
export * from "./Mtr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2dc6c28",
  null
  
)

export default component.exports